export { default } from './CarouselProductsList';
